import type { ComponentChildren } from "preact";
import { useEffect, useRef } from "preact/hooks";

export function Modal({ title, onClose, children, wide }: { title: string; onClose: () => void; children: ComponentChildren; wide?: boolean }) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const d = ref.current!;
    d.showModal();
    const close = () => onClose();
    d.addEventListener("close", close);
    return () => d.removeEventListener("close", close);
  }, []);
  return (
    <dialog ref={ref} style={wide ? "width:min(1080px,96vw)" : ""} onClick={(e) => { if (e.target === ref.current) ref.current!.close(); }}>
      <div style="display:flex;justify-content:space-between;align-items:start;gap:1rem">
        <h3>{title}</h3>
        <button class="linkish" style="font-size:22px;text-decoration:none" onClick={() => ref.current!.close()} aria-label="Zatvori">×</button>
      </div>
      {children}
    </dialog>
  );
}
